// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3H-eD","col":"styles_col__3iWV_"};